module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Tulip-Fever.1a6f703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Tulip-Fever.jpg
// module id = lnKD
// module chunks = 0